var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.$store.getters.language["fd.mixins.ViewFile.wenjianliebiao"],
        width: 800,
        visible: _vm.visible,
        maskClosable: false,
        switchFullscreen: false,
        fullscreen: false
      },
      on: {
        ok: function($event) {
          _vm.visible = false
        },
        cancel: function($event) {
          _vm.visible = false
        }
      }
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "a-button",
            {
              key: "submit",
              attrs: { type: "default" },
              on: {
                click: function($event) {
                  _vm.visible = false
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$store.getters.language["common.closeButton"]) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c("a-list", {
        attrs: { "item-layout": "horizontal", "data-source": _vm.files },
        scopedSlots: _vm._u([
          {
            key: "renderItem",
            fn: function(item, index) {
              return _c("a-list-item", {}, [
                _vm.previewSupport(item)
                  ? _c(
                      "a",
                      {
                        attrs: { slot: "actions" },
                        on: {
                          click: function($event) {
                            return _vm.preview(item)
                          }
                        },
                        slot: "actions"
                      },
                      [
                        _c("a-icon", { attrs: { type: "eye" } }),
                        _vm._v(
                          _vm._s(_vm.$store.getters.language["common.preview"])
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "a",
                  {
                    attrs: { slot: "actions" },
                    on: {
                      click: function($event) {
                        return _vm.download(item)
                      }
                    },
                    slot: "actions"
                  },
                  [
                    _c("a-icon", { attrs: { type: "download" } }),
                    _vm._v(
                      _vm._s(
                        _vm.$store.getters.language["fd.mixins.ViewFile.xiazai"]
                      )
                    )
                  ],
                  1
                ),
                _vm._v("\n      " + _vm._s(item) + "\n    ")
              ])
            }
          }
        ])
      }),
      _c(
        "j-modal",
        {
          attrs: {
            visible: _vm.previewVisible,
            fullscreen: true,
            footer: null
          },
          on: {
            cancel: function($event) {
              _vm.previewVisible = false
            }
          }
        },
        [
          _vm.previewVisible
            ? _c("img", {
                staticStyle: { width: "100%" },
                attrs: { alt: "example", src: _vm.previewImage },
                on: {
                  click: function($event) {
                    _vm.previewVisible = false
                  }
                }
              })
            : _vm._e()
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }